var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SSelect',{attrs:{"value":_vm.value,"items":_vm.staffList,"label":_vm.label,"item-value":"id","item-text":val => `${val.firstName} ${val.lastNme}`,"hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }